import { combineReducers } from '@ngrx/store';
import { riskProfile, riskProfileError, riskProfileId } from './risk-profiles/risk-profile.reducer';
export const rootReducer = combineReducers({ riskProfileId, riskProfile, riskProfileError });
